import { DefendentInLegalAction } from './components/DefendantInLegalAction';
import { DelinquentOnRealEstateDebt } from './components/DelinquentOnRealEstateDebt';
import { DelinquentOnTaxes } from './components/DeliquentOnTaxes';
import { FinanciallyWorseOffThanLastApplication } from './components/FinanciallyWorseOffThanLastApplication';
import { InvolvedInJudgements } from './components/InvolvedInJudgements';
import { LegalExplanations } from './components/LegalExplanations';
import { useBorrowerFirstLoanWithBfi } from '../../../../../../queries/BorrowerFields/CoreFields';
import {
    useBorrowerIsDefendantInLegalActions,
    useBorrowerIsInvolvedInJudgements,
    useBorrowerIsDelinquentOnDebts,
    useBorrowerIsDelinquentOnTaxes,
    useBorrowerIsFinanciallyWorseOff,
    useBorrowerLegalExplanations,
} from '../../../../../../queries/BorrowerFields/LegalityFields';
import { ShowIf } from '../../../../../components/ShowIf';
import { useEffect } from 'react';

interface LegalityVerificationProps {
    required: boolean;
    isReview?: boolean;
}

export const LegalityVerification: React.FC<LegalityVerificationProps> = ({ required, isReview = false }) => {
    const [firstLoanWithBfi] = useBorrowerFirstLoanWithBfi();
    const [defendentinLegalAction] = useBorrowerIsDefendantInLegalActions();
    const [involvedInJudgement] = useBorrowerIsInvolvedInJudgements();
    const [delinquentOnDebts] = useBorrowerIsDelinquentOnDebts();
    const [delinquentOnTaxes] = useBorrowerIsDelinquentOnTaxes();
    const [financiallyWorseOff] = useBorrowerIsFinanciallyWorseOff();
    const [legalExplanations, set_legalExplanations] = useBorrowerLegalExplanations();

    function isTrue(value: unknown): boolean {
        return value === true || value === 'true';
    }

    const shouldShowLegal =
        isTrue(defendentinLegalAction) ||
        isTrue(involvedInJudgement) ||
        isTrue(delinquentOnDebts) ||
        isTrue(delinquentOnTaxes) ||
        isTrue(financiallyWorseOff);

    useEffect(() => {
        if (!shouldShowLegal && legalExplanations !== '') {
            set_legalExplanations('');
        }
    }, [shouldShowLegal, legalExplanations, set_legalExplanations]);

    const getLegalityLabel = () => {
        const labelText = 'Currently, are you, your organization, and/or an owner or officer of your organization:';
        if (isReview) {
            return <h4>{labelText}</h4>;
        } else {
            return <h3>{labelText}</h3>;
        }
    };

    return (
        <>
            <div style={{ marginTop: '20px' }}>
                {getLegalityLabel()}
                <DefendentInLegalAction
                    required={required}
                    isReview={isReview}
                />
                <InvolvedInJudgements
                    required={required}
                    isReview={isReview}
                />
                <DelinquentOnRealEstateDebt
                    required={required}
                    isReview={isReview}
                />
                <DelinquentOnTaxes
                    required={required}
                    isReview={isReview}
                />
                <ShowIf showIf={firstLoanWithBfi === false}>
                    <FinanciallyWorseOffThanLastApplication
                        required={required}
                        isReview={isReview}
                    />
                </ShowIf>
                <ShowIf showIf={shouldShowLegal}>
                    <LegalExplanations
                        required={required}
                        isReview={isReview}
                    />
                </ShowIf>
            </div>
        </>
    );
};
